<template>
    <div class="vh-100">
        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>
        <form id="form-proper" >
            <div>
                <div class="row mt-3">
                   <div class="col-3">
                        <h5>Sites</h5>
                        <input type="text" v-model="searchQuery" class="form-control mb-2" placeholder="Search sites..." />
                        <ul v-if="filteredSites.length > 0" class="list-group list-group-flush" style="width: 100%; height: calc(100% - 55px); overflow-y: auto">
                            <li v-for="site in filteredSites" :key="site.id" class="list-group-item" style="height: 55px; font-size: 14px;" @click.prevent="selectSite(site)">
                                <div class="row" style="height: 22px">
                                    <div class="col-md-12">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ site.name }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div v-else class="p-3">
                            <small>No sites to display</small>
                        </div>
                    </div>
                    <div class="col-4">
                        <h5>Terminals</h5>
                            <ul v-if="siteOptions.length > 0" class="list-group list-group-flush" style="width: 100%">
                            <ul v-if="selectedSite != null && terminalOptions.length > 0" class="list-group list-group-flush" style="width: 100%">
                                    <template v-for="terminal in terminalOptions" >
                                        <li class="list-group-item" style="height: 55px; font-size: 14px;" :key="terminal.id" >
                                            <div class="row" style="height: 22px">
                                                <a-checkbox 
                                                    class="col-md-12"
                                                    :checked="isTerminalSelected(terminal.id)"
                                                    @change="toggleTerminal(terminal)"
                                                >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ terminal.name }}
                                                </a-checkbox>
                                            </div>
                                        </li>
                                    </template>
                            </ul>
                            <ul v-else class="list-group list-group-flush p-3" style="width: 100%">
                                <small>No terminals to display</small>
                            </ul>
                        </ul>
                    </div>
                    <div class="col-5">
                         <h5>Selected Terminals:</h5>
                        <div class="selected-terminals-container">
                            <span v-for="terminal in addedTerminals" :key="terminal.id" class="terminal-tag">
                                {{ terminal.name }} 
                                <!-- ✖ -->
                                <button @click="removeTerminal(terminal.id)" class="remove-btn">✖</button>
                            </span>
                        </div>
                        <br>
                        <button  type="button" class="btn btn-primary btn-sm float-right" @click.prevent="updatePurchase">Save</button> 
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import { mapState } from 'vuex'
    import moment from 'moment'
    var component_x;
    export default {
        props: {
            type: {
            type: String
            },
            title: String,
            accountPosWaveletId: {
            type: Number, 
            required: true 
            },
            waveletId: {  
            type: Number, 
            required: true 
            }
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
            selectedTerminalNames() {
                return this.addedTerminals.map(t => t.name).join(", ");
            },
             filteredSites() {
                return this.siteOptions.filter(site => 
                    site.name.toLowerCase().includes(this.searchQuery.toLowerCase())
                );
            }
        },
        mounted: async function () {
            component_x = this
            component_x.site_id = component_x.profileId
            let sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?mode=all", null);
            component_x.siteOptions = sites;

            let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + component_x.site_id, null);
            component_x.terminalOptions = terminals;
   
            if (component_x.profileId > 0){
                let wavelet_site_terminals = await HTTPRequest.getRequest(component_x.endPoint + 'pos_wavelet_terminals/get_terminals_by_site_id?site_id=' + component_x.site_id+'&account_pos_wavelet_id='+component_x.accountPosWaveletId, null)
                if(wavelet_site_terminals == undefined){
                    component_x.$router.go()
                } else {
                    if(wavelet_site_terminals["error"] == undefined){
                        component_x.selectedTerminals = wavelet_site_terminals.terminal_ids
                        component_x.siteName = wavelet_site_terminals.site_name
                    } else {
                        this.errors = wavelet_site_terminals["error"].split(",");
                    } 
                }
            }
            this.dynamicFormKey++;
        },
        data: function () {
            return {
                errors: [],
                profileData: {},
                dynamicFormKey: 0,
                formErrors: [],
                terminalOptions: [],
                selectedTerminals: [],
                siteName: '',
                site_id: null,
                siteOptions: [],
                terminalOptions: [],
                selectedSite: null,
                addedTerminals: [],
                searchQuery: '',
                mode: 3,

            }
        },

        methods: {
            async updatePurchase(){
                this.selectedTerminals = this.addedTerminals.map(terminal => terminal.id);
                let wavelet_payload = {"wavelet_id": this.waveletId, "selected_terminal_ids": this.selectedTerminals, "mode": this.mode}
                let post_request = await HTTPRequest.postRequest(this.endPoint + 'wavelets/update_purchase_settings', null, wavelet_payload)
                if (post_request.status == 'success') {
                    this.$notification['success']({
                        message: 'Wavelet Markeplace',
                        description: "Purchase update success"
                    });
                    this.$emit('refreshPage', event)
                } else {
                    this.$notification['error']({
                        message: 'Wavelet Marketplace',
                        description: "Purchase update error: " + post_request.error
                    }); 
                }
            },
            isTerminalSelected(terminalId) {
                return this.addedTerminals.some(t => t.id === terminalId);
            },
            toggleTerminal(terminal) {
                const index = this.addedTerminals.findIndex(t => t.id === terminal.id);
                if (index === -1) {
                    this.addedTerminals.push({ id: terminal.id, name: terminal.name });
                } else {
                    this.addedTerminals.splice(index, 1);
                }
            },
            removeTerminal(terminalId) {
                this.addedTerminals = this.addedTerminals.filter(t => t.id !== terminalId);
            },
            addTerminals(terminal) {
                const index = this.addedTerminals.findIndex(t => t.id === terminal.id);
                if (index === -1) {
                    this.addedTerminals.push({ id: terminal.id, name: terminal.name });
                } else {
                    this.addedTerminals.splice(index, 1);
                }
            },
            async selectSite(site) {
                this.selectedSite = site.id
                let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + site.id, null);
                component_x.terminalOptions = terminals;
    
            },
        },
        
    }
</script>

<style>
.selected-terminals-container {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    min-height: 40px;
    background: #f8f9fa;
}

.terminal-tag {
    background: #007bff;
    color: white;
    padding: 2px 10px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 5px;
}

.remove-btn {
    background: none;
    border: none;
    color: darkred;
    cursor: pointer;
    font-size: 12px;
}
</style>